import homeImg from "../assets/nav-home.jpeg";
import gameImg from "../assets/nav-game.jpeg";
import workImg from "../assets/nav-work.jpeg";
import aiImg from "../assets/nav-ai.jpeg";
import contactImg from "../assets/nav-contact.jpeg";

export const navImageMap = {
  "/": homeImg,
  "/game-zone": gameImg,
  "/my-work": workImg,
  "/ai": aiImg,
  "/contact": contactImg,
};

export const portfolioData = {

  profile: {},
  navItems: [
    { label: "Home", path: "/", image: homeImg },
    { label: "Game Zone", path: "/game-zone", image: gameImg },
    { label: "My Work", path: "/my-work", image: workImg },
    { label: "AI", path: "/ai", image: aiImg },
    { label: "Contact Me", path: "/contact", image: contactImg },
  ],

  workItems: [
  ],

  workItemsTimeline: [
  ],

  games: [
  ],

  aiItems: [
  ],
};